<form [formGroup]="reportForm" (ngSubmit)="updateOrCreateReport()">
  <mat-dialog-content>
    <div>
      <div>
        @if (!editMode) {
          <h2 mat-dialog-title>Report anlegen</h2>
        }
        @if (editMode) {
          <h2 mat-dialog-title>Report editieren</h2>
        }
        <!-- <h4 *ngIf="!data.id">Neues Projekt anlegen</h4>
        <h4 *ngIf="data.id">Projekt {{ data.name }} editieren</h4> -->
        <mat-divider></mat-divider>

        <mat-form-field>
          <mat-label>Name</mat-label>
          <input matInput formControlName="name" required />
        </mat-form-field>

        <mat-form-field>
          <mat-label>Projekt</mat-label>
          <mat-select formControlName="projects" required>
            @for (project of availableProjects; track project) {
              <mat-option
                matInput
                [value]="project.id"
                >{{ project.name }}</mat-option
                >
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <span>Reihenfolge Module:</span>
      <div
        cdkDropList
        class="reordering-modules-list w-full"
        (cdkDropListDropped)="reorderElementsDropEvent($event)"
        >
        @for (mir of modulesInReport; track mir) {
          <div
            class="reodering-list-box w-full"
            cdkDrag
            >
            <div class="reodering-list-label w-full" *cdkDragPlaceholder></div>
            <span
              >{{ displayNamesModules.get(mir.type) }}:
              <b>{{ mir.headline }}</b></span
              >
            </div>
          }
        </div>
      </mat-dialog-content>
      <mat-dialog-actions align="end">
        <button
          mat-raised-button
          color="primary"
          type="submit"
          [disabled]="!reportForm.valid"
          >
          @if (data.id && !editMode) {
            Report anlegen
          }
          @if (editMode) {
            Speichern
          }
        </button>
        @if (editMode) {
          <button mat-raised-button (click)="deleteReport($event)">
            {{ currentReport.name }} löschen
          </button>
        }
        <button mat-raised-button [mat-dialog-close]="true">Schließen</button>
      </mat-dialog-actions>
    </form>
